export default __webpack_public_path__ + "static/media/Andrea Leite.8006d758.jpg";